module.exports = __webpack_public_path__ + "static/media/edi6.95bed55a.jpeg";